<template>
  <div class="d-flex justify-content-between flex-wrap" style="margin-bottom: 24px; gap: 4px">
    <div><h2>Open Positions</h2></div>
    <div class="search-input-container">
      <IconMagnifyingGlass />
      <input
        v-model="searchValue"
        class="form-control"
        type="text"
        placeholder="Search for title, keyword..."
        @input="debouncedSearch"
        aria-label="Search for title, keyword..."
      />
    </div>
  </div>

  <!--Search and filters will be handled when we develop the azure search-->
  <div class="d-flex gap-2 flex-wrap mb-3 align-items-center" style="margin-bottom: 16px">
    <div>
      <button class="btn btn-filters btn-bordered btn-outlined-black" :class="{ active: openPositionsModal.selectedCategory == '' }" @click="changeSelectedCategory('')" :value="''">All</button>
    </div>
    <div v-for="term in openPositionsModal.careerCategories" :key="term">
      <button
        :class="[
          'btn',
          'btn-filters',
          'btn-bordered',
          'btn-outlined-black',
          { active: term === openPositionsModal.selectedCategory }
        ]"
        :value="term"
        @click="changeSelectedCategory(term)"
      >
        <span>{{ term }}</span>
      </button>
    </div>
  </div>
  <div v-if="!loadStore.isLoading">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div v-if="openPositionsModal.items.length > 0">

        Showing {{ (openPositionsModal.size * (paginationStore.currentPage - 1)) + 1 }} -
        {{
          (openPositionsModal.size * paginationStore.currentPage) <= openPositionsModal.totalResults
            ? openPositionsModal.size * paginationStore.currentPage
            : openPositionsModal.totalResults
        }}
        of {{ openPositionsModal.totalResults }} results
      </div>
      <div v-else> 0 results </div>
      <button
        v-if="!openPositionsModal.showAll"
        @click="openPositionsModal.setViewAllPreview()"
        class="btn btn-light pt-0 pb-2"
      >
        View All
      </button>
    </div>
  </div>
</template>
<script setup lang="ts">
import debounce from 'lodash/debounce'
import { useOpenPositionModal } from '~/stores/modals/open-position-modal'

const paginationStore = usePaginationStore()

const openPositionsModal = useOpenPositionModal()
const loadStore = useLoadingStore()
const searchValue = ref(openPositionsModal.searchValue)
function changeSelectedCategory(categoryName: string) {
  if (categoryName === openPositionsModal.selectedCategory) {
    openPositionsModal.setSelectedCategory('')
    return
  }
  openPositionsModal.setSelectedCategory(categoryName)
}
const debouncedSearch = debounce(() => openPositionsModal.setSearchValue(searchValue.value), 1000)
</script>
